// This file has external dependencies. HomePage uses TotalJobsGroup.localStorage.

var TotalJobsGroup = TotalJobsGroup || {};
TotalJobsGroup.localStorage = TotalJobsGroup.localStorage || (function ($)
{
    "use strict";

    function getItem(key)
    {
        return window.localStorage.getItem(key);
    }

    function setItem(key, value)
    {
        window.localStorage.setItem(key, value);
    }

    function isLocalStorageSupported()
    {
        try
        {
            window.localStorage.setItem("isLocalStorageSupported", "true");
            window.localStorage.removeItem("isLocalStorageSupported");
            return true;
        }
        catch (e)
        {
            return false;
        }
    }

    return {
        getItem: getItem,
        setItem: setItem,
        isLocalStorageSupported: isLocalStorageSupported
    };
})(jQuery);